export default __webpack_public_path__ + "static/media/banner01.80f4431a.png";